import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Service from "../../../assets/img/Featured/app-service.png";
import Service2 from "../../../assets/img/Featured/app-service2.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const ValetPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page valetPage">
            <div className="background" />
            <Header />
            <div className="page-header">Hotel</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Valet</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Whether it's at check-out or retrieving a guest
                    vehicle for an exciting outing, your guests expect
                    real-time 24-hour service. Ensure a positive
                    experience with mobile 2-way messaging and
                    efficient service routing to ensure high
                    satisfaction scores.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Hotel - Valet", "Service");
                    addFlow("Service");
                    navigate("/solutions/service")}}>
                    <img src={Service} alt="" />
                    <img src={Service2} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Service
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default ValetPage;